"use client";

interface IHotelServiceTagItem {
  readonly item_name?: string;
  readonly title?: string | null;
  readonly documentId?: string;
  readonly side_popup_icon?: string | null;
}

export interface IHotelServiceTagProps {
  readonly serviceIcons: readonly IHotelServiceTagItem[] | null;
}

/**
 * HotelServiceTag Component
 * Displays up to three service tags for a hotel card.
 */

export function HotelServiceTag(props: Readonly<IHotelServiceTagProps>) {
  const { serviceIcons } = props;

  // Skip rendering if no services are provided
  if (!serviceIcons?.length) return null;

  // Limit display to first four items for layout consistency
  const visibleItems = serviceIcons.slice(0, 4);

  return (
    <div className="relative mt-2 mb-2 flex flex-wrap gap-2">
      {visibleItems.map((i) => (
        <div
          key={i.documentId}
          className="bg-primary-100 flex items-center rounded-full px-2 py-1 whitespace-nowrap"
        >
          {/* Render icon if available */}
          <i className={`ico ${i.side_popup_icon ?? ""}`}></i>
          <span className="ml-1 text-xs text-gray-600">{i.title}</span>
        </div>
      ))}
    </div>
  );
}
